import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import {
  ApiCredential, CredentialTypes,
  LocalCredential,
  ProxyCredential, READABLE_CREDENTIAL_TYPES
} from "@fry/lib/auth/account/credential/credential";

@Component({
    selector: 'eas-user-credential',
    templateUrl: './user-credential.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class UserCredentialComponent implements OnChanges {

  @Input() credential: LocalCredential | ProxyCredential | ApiCredential;
  @Input() editable: boolean;
  @Output() updated = new EventEmitter<void>();

  constructor(
  ) {}

  ngOnChanges() {
  }

  protected readonly CredentialTypes = CredentialTypes;
  protected readonly READABLE_CREDENTIAL_TYPES = READABLE_CREDENTIAL_TYPES;
}
